<template>
  <div class="min-h-screen flex flex-col items-center justify-center fade-in">
    <div class="about-content text-center bg-white bg-opacity-100 p-8 rounded-lg">
      <h1 class="text-4xl font-bold text-gray-800 mb-4">About Me</h1>
      <div class="text-center">
        <p class="text-xl text-gray-600 mb-6">
          I am a full-stack web developer with a passion for creating web applications. In my free time, I am a hobbyist
          music producer.
        </p>
        <h2 class="text-2xl text-black-600 mb-6"> Technical Experience </h2>
        <p class="text-xl text-gray-600 mb-6">
          My experience includes working with HTML, CSS (including frameworks like Bootstrap and Tailwind), JavaScript,
          TypeScript, React, Node.js, Express, NoSQL, MongoDB, PostgresSQL, Python, CI/CD pipelines, and now Vue.js (What this
          site is made with).
        </p>
        <h2 class="text-2xl text-black-600 mb-6"> Future Goals </h2>
        <p class="text-xl text-gray-600 mb-6">
          As a motivated junior developer, I am always looking to learn new technologies and improve my skills.
          My current goal is to start a career in web development and improve my skill set, while learning new skills along the way.
        </p>
        <h2 class="text-2xl text-black-600 mb-6"> About this Site </h2>
        <p class="text-xl text-gray-600 mb-6">
          This site was created using Vue.js and Tailwind CSS. It is a single-page application that uses Vue Router to
          navigate between pages. Creating this portfolio was my entry into learning Vue.js.
        </p>
      </div>
      <div class="space-x-4">
        <router-link to="/projects"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Projects</router-link>
        <router-link to="/contact"
          class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
};
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

p {
  text-align: center;
}

.fade-in {
  animation: fadeIn 1s ease-in;
}

.about-content {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  max-width: 700px;
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
}
</style>